import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { scrollToId } from "./Header";
import { SERVICES } from "@/data/services";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#EFEBE2] py-16 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div data-testid="services-divider" aria-hidden="true" className="md:col-span-12 flex items-center justify-center gap-6 -mb-2">
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
        <img src="/assets/nua-mark-transparent.png" alt="" className="h-9 w-auto opacity-90" />
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
      </div>
      <div className="md:col-span-4">
        <div className="md:sticky md:top-28">
          <Reveal>
            <p className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-[#0A2333]">
              <span className="h-px w-10 bg-[#0A2333]" aria-hidden="true" />
              What we advise on
            </p>
            <h2 data-testid="services-heading" className="mt-6 font-serif text-3xl md:text-4xl tracking-tight text-[#111413]">
              Independent financial advice to help guide you through life.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-[#4A524D]">
              We provide comprehensive independent financial advice tailored to your goals—including
              retirement planning, wealth accumulation, superannuation, Commonwealth Superannuation
              Schemes, investment strategies, and tax-efficient wealth management, among other
              specialized areas. Our priority is delivering clear, actionable strategies, and if we
              aren't the right fit to add value, we will guide you toward an expert who is.
            </p>
            <button
              data-testid="services-cta"
              onClick={() => scrollToId("contact")}
              className="relative after:absolute after:-inset-y-3 after:inset-x-0 after:content-[''] mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#111413] underline decoration-[#A78558] decoration-2 underline-offset-8 hover:text-[#0A2333] transition-colors duration-300"
            >
              Discuss your situation
              <ArrowUpRight size={14} />
            </button>
          </Reveal>
        </div>
      </div>

      <div className="md:col-span-8">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.05}>
            <Link
              to={`/services/${s.slug}`}
              data-testid={`service-row-${s.n}`}
              className="group grid grid-cols-12 items-baseline gap-x-4 gap-y-2 border-t border-black/15 px-2 md:px-4 py-8 transition-[background-color] duration-300 hover:bg-[#F9F8F4]"
            >
              <span className="col-span-2 md:col-span-1 font-serif italic text-lg text-[#A78558]">{s.n}</span>
              <h3 className="col-span-10 md:col-span-4 font-serif text-2xl md:text-3xl tracking-tight text-[#111413]">
                {s.title}
              </h3>
              <p className="col-span-10 col-start-3 md:col-span-6 md:col-start-6 text-sm leading-relaxed text-[#4A524D]">
                {s.body}
              </p>
              <ArrowUpRight
                aria-hidden="true"
                className="hidden md:block col-span-1 justify-self-end text-[#0A2333] opacity-0 -translate-x-2 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0"
                size={20}
              />
            </Link>
          </Reveal>
        ))}
        <div className="border-t border-black/15" aria-hidden="true" />
      </div>
    </div>
  </section>
);
